// Gavedrysset JavaScript entry point (bundled by esbuild, IIFE format).
// Hotwire: Turbo drives navigation/forms, Stimulus drives the few client-side
// behaviors the pop-art UI needs.
import "@hotwired/turbo-rails"

import { Application } from "@hotwired/stimulus"

import BuyController from "./controllers/buy_controller"
import ClipboardController from "./controllers/clipboard_controller"
import DialogController from "./controllers/dialog_controller"
import FlashController from "./controllers/flash_controller"
import LinkPreviewController from "./controllers/link_preview_controller"
import ToggleBoughtController from "./controllers/toggle_bought_controller"
import TryListController from "./controllers/try_list_controller"
import WishEditorController from "./controllers/wish_editor_controller"

const application = Application.start()
application.register("buy", BuyController)
application.register("clipboard", ClipboardController)
application.register("dialog", DialogController)
application.register("flash", FlashController)
application.register("link-preview", LinkPreviewController)
application.register("toggle-bought", ToggleBoughtController)
application.register("try-list", TryListController)
application.register("wish-editor", WishEditorController)
